// Single source of truth for the Pipeline Command Centre dropdowns and
// stage journey. Whenever a lender / credit-team member / purpose / stage
// changes, edit it HERE and every dropdown, chart and filter updates.
//
// The 8-stage client journey extends the existing status_stage values —
// old deals with just "submitted / approved / settled" continue to work.

export const LENDERS = [
  'CBA',
  'NAB',
  'ANZ',
  'Westpac',
  'Macquarie',
  'ING',
  'Bankwest',
  'Bluestone Mortgages',
  'MA Money',
  'Bendigo Bank',
];

export const CREDIT_TEAM = [
  'Tarah',
  'Jass',
  'Underwriter 1',
  'Underwriter 2',
];

export const LOAN_PURPOSES = [
  'First home purchase',
  'Investment purchase',
  'Owner-occupied refi',
  'Investment refi',
  'Cash-out / equity release',
  'Consolidation',
  'Construction',
  'Bridging',
  'Other',
];

export const APPLICATION_TYPES = [
  'Standard PAYG',
  'Self-employed',
  'Company / Trust',
  'SMSF',
  'Guarantor',
  'Bridging',
  'Construction',
];

// 8-stage client journey — the funnel goes top to bottom. `key` is what
// gets stored in the deal's `status_stage` field. `dateField` is the
// timestamp on the deal that marks entry into that stage (used for
// time-at-stage and turnaround analytics).
export const PIPELINE_STAGES = [
  { key: 'lead_received',          label: 'Lead received',          dateField: 'lead_received_date',          tone: '#60a5fa' },
  { key: 'portal_sent',            label: 'Client portal sent',     dateField: 'portal_sent_date',            tone: '#3b82f6' },
  { key: 'portal_completed',       label: 'Client portal completed',dateField: 'portal_completed_date',       tone: '#8b5cf6' },
  { key: 'proposal_prepared',      label: 'Proposal prepared',      dateField: 'proposal_date',               tone: '#a855f7' },
  { key: 'submitted',              label: 'Application submitted',  dateField: 'submitted_date',              tone: '#f59e0b' },
  { key: 'conditional_approval',   label: 'Conditional approval',   dateField: 'conditional_approval_date',   tone: '#eab308' },
  { key: 'unconditional_approval', label: 'Unconditional approval', dateField: 'unconditional_approval_date', tone: '#10b981' },
  { key: 'settled',                label: 'Settlement',             dateField: 'settled_date',                tone: '#0ea5e9' },
];

// Terminal / off-pipeline states — surfaced separately (they are not part
// of the healthy funnel).
export const TERMINAL_STAGES = [
  { key: 'declined',   label: 'Declined',   tone: '#ef4444' },
  { key: 'withdrawn',  label: 'Withdrawn',  tone: '#94a3b8' },
  { key: 'on_hold',    label: 'On hold',    tone: '#f97316' },
];

export const HOLD_REASONS = [
  'Waiting on client documents',
  'Waiting on valuation',
  'Waiting on lender response',
  'Client requested delay',
  'Compliance check',
  'Other',
];

export const DECLINE_REASONS = [
  'Serviceability',
  'Credit history',
  'Deposit / LVR',
  'Employment',
  'Property',
  'Policy',
  'Other',
];

export const WITHDRAWAL_REASONS = [
  'Client withdrew',
  'Went with another broker',
  'Went direct to lender',
  'Purchase fell through',
  'Circumstances changed',
  'Other',
];
